<template>
	<!-- Shape of pages/home.vue: full-bleed rotator hero, then horizontal card scrollers. -->
	<div class="space-y-2" aria-hidden="true">
		<!-- Rotator hero -->
		<Skeleton rounded="rounded-none" class="w-full h-[55vh] md:h-[70vh]" />

		<!-- Podcasts scroller -->
		<div class="py-8">
			<Skeleton class="h-5 w-32 mx-8" />
			<div class="flex overflow-hidden pt-4 w-full space-x-4 md:space-x-6 px-8">
				<Skeleton v-for="n in 5" :key="n" rounded="rounded" class="aspect-square w-2/3 max-w-sm shrink-0" />
			</div>
		</div>

		<!-- "Find Resources On..." scroller -->
		<div class="pb-8">
			<Skeleton class="h-5 w-48 mx-8" />
			<div class="flex overflow-hidden pt-4 w-full space-x-4 md:space-x-6 px-8">
				<Skeleton v-for="n in 4" :key="n" rounded="rounded" class="aspect-video w-2/3 max-w-sm shrink-0" />
			</div>
		</div>

		<!-- Products scroller -->
		<div class="pb-8">
			<Skeleton class="h-5 w-40 mx-8" />
			<div class="flex overflow-hidden pt-4 w-full space-x-6 px-8">
				<Skeleton v-for="n in 5" :key="n" rounded="rounded" class="aspect-[3/4] w-1/3 max-w-[12rem] shrink-0" />
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'

export default {
	name: 'HomeSkeleton',
	components: { Skeleton },
}
</script>
